const Env = {
  REQUEST_CAIPIRINHA_HOST: 'https://pagamento-api.magazineluiza.com.br',
  PAYMENT_HOST: 'https://pagamento-cartao.magazineluiza.com.br',
  TRACKING_ID: 'G-3M8S56TLH1',
  GTM_ID: 'GTM-NTLKLM9',
  PIX_MIN_TO_EXPIRED: 60,
  TMX_ORD_ID: '5cfbehmb',
  TMX_PROFILE_DOMAIN: 'h.online-metrix.net',
};

export default Env;
